module.exports = __webpack_public_path__ + "52c80a4cc5e0d0262c31576365a6f956.pdf";